const withLeadingZero = (units: number): string =>
  units < 10 ? `0${units}` : `${units}`;

export const secondsToTimeUnits = (
  seconds: number
): {
  hours: number;
  minutes: number;
  seconds: number;
} => ({
  hours: Math.floor(seconds / 3600),
  minutes: Math.floor((seconds % 3600) / 60),
  seconds: Math.floor(seconds % 60)
});

export const secondsToFormattedTimeUnits = (
  seconds: number
): {
  hours: string;
  minutes: string;
  seconds: string;
} => {
  const timeUnits = secondsToTimeUnits(seconds);
  return {
    hours: withLeadingZero(timeUnits.hours),
    minutes: withLeadingZero(timeUnits.minutes),
    seconds: withLeadingZero(timeUnits.seconds)
  };
};

export const secondsToHHMMSSFormat = (timeInSeconds?: number): string => {
  if (timeInSeconds === undefined) {
    return "";
  }

  const { hours, minutes, seconds } = secondsToTimeUnits(timeInSeconds);

  if ([hours, minutes, seconds].some(timeUnit => isNaN(timeUnit))) {
    return "";
  }

  return `${hours > 0 ? hours + ":" : ""}${
    hours ? withLeadingZero(minutes) : minutes
  }:${withLeadingZero(seconds)}`;
};

export const getTimeRemaining = (
  currentTime: number,
  duration: number
): number => {
  return Math.max(Math.round(duration - currentTime), 0);
};
